import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeSmart } from '@at/design-system-foundation'

const transition = 'visibility 0.2s, opacity 0.2s ease-in-out'

export const StyledTooltipMessage = styled(TypeSmart)<{ $position: string; $width: string }>`
    ${({ theme, $position, $width }) => {
        return css`
            background-color: ${theme.color.bgFill.intense};
            border-radius: ${ThemeSelectors.getLegacyGridUnit(theme) / 2}px;
            bottom: -${ThemeSelectors.getGridUnit(theme)};
            color: ${theme.color.text.intense.onFill};
            cursor: auto;
            height: auto;
            opacity: 0;
            padding: ${ThemeSelectors.getLegacyGridUnit(theme) * 1.5}px;
            position: absolute;
            right: ${$position === 'right' ? '-50%' : ''};
            left: ${$position === 'left' ? `-${$width}px` : ''};
            transform: translate(0, 100%);
            transition: ${transition};
            visibility: hidden;
            width: 250px;
            z-index: 6;
        `
    }}
`

export const StyledTooltip = styled.div`
    ${({ theme }) => {
        return css`
            & svg {
                background-color: ${theme.color.bgSurface.default};
            }
            &:focus,
            &:hover {
                &:before,
                ${StyledTooltipMessage} {
                    opacity: 1;
                    visibility: visible;
                }
            }
            &:before {
                border-color: ${theme.color.border.intense} transparent;
                border-style: solid;
                border-width: 0 ${ThemeSelectors.getGridUnit(theme)} ${ThemeSelectors.getGridUnit(theme)};
                bottom: -${ThemeSelectors.getGridUnit(theme)};
                content: '';
                opacity: 0;
                position: absolute;
                right: 50%;
                transform: translate(50%, 0);
                transition: ${transition};
                visibility: hidden;
            }
            cursor: help;
            display: flex;
            height: 100%;
            justify-content: center;
            position: relative;
            width: 30px;
            z-index: 6; // so the (i) icon can be clicked on when on the sort button in search results
        `
    }}
`
